<div mat-dialog-content style="height: 100%;">
  <iframe style="width: 100%; height: 100%" [src]="url" title="Tranzpay">
  </iframe>
</div>
